import isEmpty from 'lodash/isEmpty';



const makeClearableUrlPrefix = (urlPrefix) => {
  return !isEmpty(urlPrefix) ? `/${urlPrefix}` : '';
};

export default makeClearableUrlPrefix;
